import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import algoliasearch from 'algoliasearch/lite';
import { InstantSearch, Hits, Configure, ScrollTo } from 'react-instantsearch-dom';

import { GetAlgoliaIndex } from '3-components/Utils/AlgoliaUtils';
import AlgoliaPagination from '3-components/AlgoliaPagination/AlgoliaPagination';
import AlgoliaSearchInput from '3-components/AlgoliaSearchInput/AlgoliaSearchInput';
import qs from 'qs';
import SearchResult from './widgets/SearchResult';
import NoResults from './widgets/NoResults';
import CustomStats from './widgets/CustomStats';
import CustomMenuFilter from './widgets/CustomMenuFilter';
import SearchTitle from './widgets/SearchTitle';
import PoweredByAlgolia from './widgets/PoweredByAlgolia';
import { dataLayerSearch } from '../../js/utils/dataLayers';

const APP_CLASS = 'algolia-search-app';
const ALGOLIA_APP_ID = '1K2NLKV3ZJ';
const ALGOLIA_API_ID = '7a32b5b2e4b7dcec55dcb2efc053fedd';
const ALGOLIA_INDEX = 'ALL_PAGES';
const DEBOUNCE_TIME = 400;

const searchClient = algoliasearch(
    ALGOLIA_APP_ID,
    ALGOLIA_API_ID
);

const createURL = state => {
    const queryParameters = {};

    if (state.query) {
        queryParameters.query = encodeURIComponent(state.query);
    }

    const queryString = qs.stringify(queryParameters, {
        addQueryPrefix: true,
        arrayFormat: 'repeat'
    });

    return `${window.location.origin}${window.location.pathname}${queryString}`;
};

const searchStateToUrl = searchState => (searchState ? createURL(searchState) : '');

const urlToSearchState = location => {
    const { query = '', page = 1 } = qs.parse(
        location.search.slice(1)
    );

    return {
        query: decodeURIComponent(query),
        page
    };
};

const AlgoliaSearchApp = () => {
    const { searchParams } = new URL(document.location);
    const defaultSearchTerm = searchParams ? searchParams.get('q') : '';

    const [searchState, setSearchState] = useState(urlToSearchState(window.location));
    const [debouncedSetState, setDebouncedSetState] = useState(null);

    const onSearchStateChange = updatedSearchState => {
        clearTimeout(debouncedSetState);

        setDebouncedSetState(
            setTimeout(() => {
                window.history.pushState(
                    updatedSearchState,
                    null,
                    searchStateToUrl(updatedSearchState)
                );

                // Search submitted data layer
                if (updatedSearchState.query !== '') {
                    const stat = parseInt(document.querySelector('.algolia-search-searchbar .custom-stats').textContent, 10);
                    dataLayerSearch(updatedSearchState.query, stat);
                }
            }, DEBOUNCE_TIME)
        );

        setSearchState(updatedSearchState);
    };

    const indexToUse = GetAlgoliaIndex(ALGOLIA_INDEX);

    return (
        <InstantSearch
            indexName={indexToUse}
            searchClient={searchClient}
            searchState={searchState}
            onSearchStateChange={onSearchStateChange}
            createURL={createURL}
        >
            <Configure
                query={defaultSearchTerm}
                hitsPerPage={9}
            />

            <SearchTitle defaultRefinement={defaultSearchTerm} />

            <div className="algolia-search-searchbar">
                <AlgoliaSearchInput defaultRefinement={defaultSearchTerm} />

                <CustomStats />
            </div>

            <ScrollTo>
                <CustomMenuFilter seeAllText="All results" filterAttribute="page_type" />

                <div className="algolia-search-results">
                    <Hits
                        hitComponent={hit => <SearchResult data={hit} searchState={searchState} />}
                    />

                    <NoResults />

                    <AlgoliaPagination />
                    <PoweredByAlgolia />
                </div>
            </ScrollTo>

        </InstantSearch>
    );
};

const el = document.getElementById(`${APP_CLASS}`);
const elProps = el?.dataset.props || '{}';
const propsObj = JSON.parse(elProps);

if (el) {
    ReactDOM.render(
        <AlgoliaSearchApp {...propsObj} />,
        el
    );
}
